export default __webpack_public_path__ + "static/media/Adobe_Illustrator_CC_icon.a57480b4.svg";